import moment from 'moment'

let getCurrentSeason = function (state, tournamentIdentifier) {
    if (tournamentIdentifier !== undefined) {
        if (tournamentIdentifier === 1072 || tournamentIdentifier === 2055 || tournamentIdentifier === 2056
            || tournamentIdentifier === 2076 || tournamentIdentifier === 2094 || tournamentIdentifier === 2052
            || tournamentIdentifier === 2080) {
            return 2024;
        }
    }
    return 2024
}

var getNormalizedWeek = function (tournament) {
    let momentAsUtc = moment.utc(tournament.startDate);
    let weekOfTournament = momentAsUtc.format("W");
    let dayOfWeek = momentAsUtc.day();
    // if sunday or saturday then add one week
    if (dayOfWeek === 0 || dayOfWeek === 6) {
        weekOfTournament = parseInt(weekOfTournament) + 1;
    }
    return parseInt(weekOfTournament);
};

const ORDER_OF_TOURNAMENTS_TO_DISPLAY = ['GrandSlam', 'PremierMandatory', 'Premier5', 'Premier', 'International', 'Challenger'];

export default {
    namespaced: true,


    state: {
        tournaments: [],
        deadlines: [],
        enterableTournaments: [],
        tournamentsForAcceptanceList: [],
        tournamentsForPrelimListDoubles: [],
        tournamentsForAcceptanceListDoubles: [],
        //currentDate: moment('2019-06-17 15:00'),
        currentDate: moment(),
        playerIdentifier: localStorage.getItem('overwrittenPlayerIdentifier') || window.playerIdentifier || '999991',
        playerPassword: "",
        tournamentSelected: '',
        deadlineSelected: null,
        withdrawableEntries: [],
        activityForPlayer: [],
        prelimEntries: {},
        acceptedEntries: {},
        prelimEntriesDoubles: {},
        acceptedEntriesDoubles: {},
        loadingWithdraw: true
    },
    getters: {
        currentDate: (state) => state.currentDate,
        tournaments: (state) => state.tournaments,
        playerIdentifier: (state) => state.playerIdentifier,
        deadlines: (state) => state.deadlines,
        withdrawableEntries: (state) => state.withdrawableEntries,
        loadingWithdraw: (state) => state.loadingWithdraw,
        activityForPlayer: (state) => state.activityForPlayer,
        prelimEntries: (state) => state.prelimEntries,
        acceptedEntries: (state) => state.acceptedEntries,
        tournamentsForAcceptanceList: (state) => state.tournamentsForAcceptanceList,
        prelimEntriesDoubles: (state) => state.prelimEntriesDoubles,
        tournamentsForPrelimListDoubles: (state) => state.tournamentsForPrelimListDoubles,
        acceptedEntriesDoubles: (state) => state.acceptedEntriesDoubles,
        tournamentsForAcceptanceListDoubles: (state) => state.tournamentsForAcceptanceListDoubles,
        enterableTournaments: (state) => state.enterableTournaments,
    },
    mutations: {
        updateWithdrawDataState(state, status) {
            state.loadingWithdraw = status;
        },
        updateTournaments(state, tournaments) {
            state.tournaments = tournaments;
        },
        updateDeadlines(state, deadlines) {
            let deadlinesAsMoment = [];
            deadlines.forEach(function (value) {
                deadlinesAsMoment.push(moment.utc(value));
            });
            state.deadlines = deadlinesAsMoment;
        },
        updateEnterable(state, tournaments) {
            let tournamentsEdited = [];
            let activeDeadline = state.deadlineSelected;
            tournaments.forEach(tinfo => {
                var value = tinfo.edition;
                value.mainEnteredByPlayerBefore = tinfo.mainEnteredByPlayerBefore;
                value.qualiEnteredByPlayerBefore = tinfo.qualiEnteredByPlayerBefore;
                value.mainPreferenceChosen = tinfo.mainPreferenceChosen;
                value.qualiPreferenceChosen = tinfo.qualiPreferenceChosen;
                value.acceptedIntoMain = tinfo.acceptedIntoMain;

                let entryMainDeadlineAsMoment = moment.utc(value.single.main.entryDeadline);
                let entryQualiDeadlineAsMoment = moment.utc(value.single.qualification.entryDeadline);
                value.mainDrawCanBeEntered = entryMainDeadlineAsMoment.isSame(activeDeadline);
                value.qualificationCanBeEntered = entryQualiDeadlineAsMoment.isSame(activeDeadline);
                tournamentsEdited.push(value);
            });
            tournamentsEdited.sort((a, b) => {
                // #7312, #7340 Ensure tournaments are listed in order
                return moment.utc(a.startDate) - moment.utc(b.startDate) ||
                    ORDER_OF_TOURNAMENTS_TO_DISPLAY.indexOf(a.level) - ORDER_OF_TOURNAMENTS_TO_DISPLAY.indexOf(b.level) ||
                    a.name.localeCompare(b.name);
            });
            state.enterableTournaments = tournamentsEdited;
        },
        updateEnterableUseCurrentDate(state, tournaments) {
            let tournamentsEdited = [];
            tournaments.forEach(tinfo => {
                var value = tinfo.edition;
                value.mainEnteredByPlayerBefore = tinfo.mainEnteredByPlayerBefore;
                value.qualiEnteredByPlayerBefore = tinfo.qualiEnteredByPlayerBefore;
                value.mainPreferenceChosen = tinfo.mainPreferenceChosen;
                value.qualiPreferenceChosen = tinfo.qualiPreferenceChosen;
                value.acceptedIntoMain = tinfo.acceptedIntoMain;

                value.mainDrawCanBeEntered = moment.utc(value.single.main.entryDeadline).isAfter(state.currentDate);
                value.qualificationCanBeEntered = moment.utc(value.single.qualification.entryDeadline).isAfter(state.currentDate);
                tournamentsEdited.push(value);
            });
            tournamentsEdited.sort((a, b) => {
                // #7312 Ensure tournaments are listed in order
                return ORDER_OF_TOURNAMENTS_TO_DISPLAY.indexOf(a.level) - ORDER_OF_TOURNAMENTS_TO_DISPLAY.indexOf(b.level);
            });
            state.enterableTournaments = tournamentsEdited;
        },
        updateDateValue(state, dateValue) {
            state.currentDate = dateValue;
        },
        updatePlayerValue(state, playerIdentifier) {
            state.playerIdentifier = playerIdentifier;
        },
        updateDeadlineSelected(state, deadline) {
            state.deadlineSelected = deadline;
        },
        updateWithdrawableEntries(state, entries) {
            state.withdrawableEntries = entries;
            state.loadingWithdraw = false;
        },
        updateActivites(state, entries) {
            state.activityForPlayer = entries;
        },
        updatePreliminaryEntriesDoubles(state, payload) {
            state.prelimEntriesDoubles[payload['tournamentIdentifier']] = payload['data'];
        },
        updatePreliminaryEntries(state, payload) {
            state.prelimEntries[payload['tournamentIdentifier']] = payload['data'];
        },
        updateTournamentsForAcceptanceList(state, payload) {
            state.tournamentsForAcceptanceList = payload;
        },
        updateAcceptedEntries(state, payload) {
            state.acceptedEntries[payload['tournamentIdentifier']] = payload['data'];
        },
        updateAcceptedEntriesDoubles(state, payload) {
            state.acceptedEntriesDoubles[payload['tournamentIdentifier']] = payload['data'];
        },
        updateTournamentsForPrelimListDoubles(state, payload) {
            state.tournamentsForPrelimListDoubles = payload;
        },
        updateTournamentsForAcceptanceListDoubles(state, payload) {
            state.tournamentsForAcceptanceListDoubles = payload;
        },
    },
    actions: {
        updateDateValue({ commit, dispatch, state }, dateValue) {
            commit('updateDateValue', dateValue);
        },
        updateDeadlineSelected({ commit, dispatch, state }, deadlineValue) {
            commit('updateDeadlineSelected', deadlineValue);
        },
        fetchIsValidUser({ commit, dispatch, state }, value) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/access?_c=' + Date.now() + '&playerIdentifier=' + value[0] + '&playerPassword=' + value[1], {
                }).then((response) => {
                    try {
                        response.json().then((data) => {
                            resolve(data);
                        }).catch((reason) => {
                            console.log('Error while checking player access ' + reason);
                            reject(reason);
                        })
                    } catch (e) {
                        reject();
                    }
                }).catch((reason) => {
                    console.log('Error while checking player access ' + reason);
                    reject(reason);
                });
            });
        },
        fetchTournaments({ commit, dispatch, state }) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/Entry/GetEnterableTournamentsFromInstant?instantAsMillis=' + state.currentDate.valueOf() + '&c=' + Date.now(), {
                }).then((response) => {
                    response.json().then(data => {
                        commit('updateTournaments', data);
                        dispatch('fetchEnterableTournaments').then(() => {
                            dispatch('fetchTournamentsForAcceptanceList');
                            resolve();
                        }).catch((error) => {
                            console.log('Error while fetching enterable tournaments ' + error);
                            reject(error);
                        });
                    });
                }).catch((reason) => {
                    console.log('Error while fetching tournaments ' + reason);
                    reject(reason);
                });
            });
        },
        fetchTournamentsForAcceptanceList({ commit, dispatch, state }) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/ForAcceptanceListPublished/' + state.currentDate.format('YYYY-MM-DD') + '?c=' + Date.now(), {
                }).then((response) => {
                    response.json().then(data => {
                        commit('updateTournamentsForAcceptanceList', data);
                        resolve();
                    });
                }).catch((reason) => {
                    console.log('Error while fetching tournaments for acceptance list' + reason);
                    reject(reason);
                });
            });
        },
        fetchTournamentsForPrelimListDoubles({ commit, dispatch, state }) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/ForPrelimListDoubles/' + state.currentDate.format('YYYY-MM-DD') + '?c=' + Date.now(), {
                }).then((response) => {
                    response.json().then(data => {
                        commit('updateTournamentsForPrelimListDoubles', data);
                        resolve();
                    });
                }).catch((reason) => {
                    console.log('Error while fetching tournaments for prelim list' + reason);
                    reject(reason);
                });
            });
        },
        fetchTournamentsForAcceptanceListDoubles({ commit, dispatch, state }) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/ForAcceptanceListDoublesPublished/' + state.currentDate.format('YYYY-MM-DD') + '?c=' + Date.now(), {
                }).then((response) => {
                    response.json().then(data => {
                        commit('updateTournamentsForAcceptanceListDoubles', data);
                        resolve();
                    });
                }).catch((reason) => {
                    console.log('Error while fetching tournaments for acceptance list' + reason);
                    reject(reason);
                });
            });
        },
        fetchDeadlines({ commit, dispatch, state }) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/Entry/GetDeadlinesAvailableForEnter?' +
                    'instantAsMillis=' + state.currentDate.valueOf() + '&c=' + Date.now(), {
                }).then((response) => {
                    response.json().then(data => {
                        commit('updateDeadlines', data);
                        commit('updateDeadlineSelected', moment.utc(data[0]));
                        dispatch('fetchTournaments').then(() => {
                            resolve();
                        }).catch((error) => {
                            console.log('Error while fetching tournaments ' + error);
                            reject(error);
                        });
                    });
                }).catch((reason) => {
                    console.log('Error while fetching deadlines ' + reason);
                    reject(reason);
                });
            });
        },
        fetchEnterableTournaments({ commit, state }, valueAsMoment) {
            let dateToBeUsed = valueAsMoment !== undefined ? valueAsMoment.valueOf() : state.currentDate.valueOf();
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/Entry/GetAllEnterableThisWeek?' +
                    'instantAsMillis=' + dateToBeUsed + '&playerIdentifier=' + state.playerIdentifier + '&c=' + Date.now(), {
                }).then((response) => {
                    response.json().then(data => {
                        commit('updateEnterable', data);
                        resolve();
                    });
                }).catch((reason) => {
                    console.log('Error while fetching enterable tournaments ' + reason);
                    reject(reason);
                });
            });
        },
        fetchEnterableTournamentsSameWeekAsInput({ commit, state }, tournamentIdentifier) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/Entry/GetAllEnterableWithSameStartDate?' +
                    'tournamentIdentifier=' + tournamentIdentifier + '&playerIdentifier=' + state.playerIdentifier + '&c=' + Date.now(), {
                }).then((response) => {
                    response.json().then(data => {
                        commit('updateEnterableUseCurrentDate', data);
                        resolve();
                    });
                }).catch((reason) => {
                    console.log('Error while fetching enterable tournaments ' + reason);
                    reject(reason);
                });
            });
        },
        updateDate({ commit, dispatch }, value) {
            return new Promise((resolve, reject) => {
                commit('updateDateValue', value);
                dispatch('fetchDeadlines').then(() => {
                    dispatch('fetchWithdrawableEntries').then(() => {
                        dispatch('fetchActivityEntries');
                        resolve();
                    });
                }).catch((reason) => {
                    console.log('Error while fetching deadlines ' + reason);
                    reject(reason);
                });
            });
        },
        updatePlayer({ commit, dispatch }, value) {
            console.log('Updating Player...');
            console.log(value);
            return new Promise((resolve, reject) => {
                commit('updatePlayerValue', value);
                dispatch('fetchEverything').then(() => {
                    dispatch("fetchWithdrawableEntries");
                    dispatch("fetchActivityEntries");
                    resolve();
                }).catch((error) => {
                    console.log('Error while fetching everything ' + error);
                    reject(error);
                });
            })
        },
        updateEnteredTournaments({ commit, state }) {
            return new Promise((resolve, reject) => {
                let tournamentsEnteredByPlayer = [];
                state.enterableTournaments.forEach(tournament => {
                    if (tournament.mainEnteredByPlayer || tournament.qualiEnteredByPlayer) {
                        if (!tournament.mainEnteredByPlayerBefore || !tournament.qualiEnteredByPlayerBefore) {
                            tournament.playerIdentifierThatEntered = state.playerIdentifier;
                            if (!tournament.mainPreference || tournament.mainPreference <= 0) {
                                tournament.mainPreference = 1;
                            }
                            if (!tournament.qualiPreference || tournament.qualiPreference <= 0) {
                                tournament.qualiPreference = 1;
                            }
                            tournamentsEnteredByPlayer.push(tournament);
                        }
                    }
                });
                if (tournamentsEnteredByPlayer.length > 0) {
                    let preferencesChosenMain = {};
                    let preferencesChosenQuali = {};

                    tournamentsEnteredByPlayer.forEach(tx => {
                        if (tx.qualiEnteredByPlayer) {
                            let val = preferencesChosenQuali[getNormalizedWeek(tx)];
                            if (!val) val = [0, 0];
                            let vPref = parseInt(tx.qualiPreference) + val[0];
                            preferencesChosenQuali[getNormalizedWeek(tx)] = [vPref, val[1] + 1];
                        }
                        if (tx.mainEnteredByPlayer) {
                            let val = preferencesChosenMain[getNormalizedWeek(tx)];
                            if (!val) val = [0, 0];
                            let vPref = parseInt(tx.mainPreference) + val[0];
                            preferencesChosenMain[getNormalizedWeek(tx)] = [vPref, val[1] + 1];
                        }
                    });

                    state.enterableTournaments.forEach(tt => {
                        if (tt.qualiEnteredByPlayerBefore) {
                            let val = preferencesChosenQuali[getNormalizedWeek(tt)];
                            if (!val) val = [0, 0];
                            let vPref = parseInt(tt.qualiPreferenceChosen) + val[0];
                            preferencesChosenQuali[getNormalizedWeek(tt)] = [vPref, val[1] + 1];
                        }
                        if (tt.mainEnteredByPlayerBefore) {
                            let val = preferencesChosenMain[getNormalizedWeek(tt)];
                            if (!val) val = [0, 0];
                            let vPref = parseInt(tt.mainPreferenceChosen) + val[0];
                            preferencesChosenMain[getNormalizedWeek(tt)] = [vPref, val[1] + 1];
                        }
                    });

                    if (tournamentsEnteredByPlayer.length >= 1) {
                        for (var key in preferencesChosenMain) {
                            let vPrefAndCount = preferencesChosenMain[key];
                            if ((vPrefAndCount[1] === 2 && vPrefAndCount[0] < 3) ||
                                (vPrefAndCount[1] === 2 && vPrefAndCount[0] === 4) ||
                                (vPrefAndCount[1] === 3 && vPrefAndCount[0] < 6) ||
                                (vPrefAndCount[1] === 4 && vPrefAndCount[0] < 10)) {
                                return reject('MD Preferences must be different for tournaments the same week or consecutive (1,2,...)');
                            }
                        }
                        for (var key in preferencesChosenQuali) {
                            let vPrefAndCount = preferencesChosenQuali[key];
                            if ((vPrefAndCount[1] === 2 && vPrefAndCount[0] < 3) ||
                                (vPrefAndCount[1] === 2 && vPrefAndCount[0] === 4) ||
                                (vPrefAndCount[1] === 3 && vPrefAndCount[0] < 6) ||
                                (vPrefAndCount[1] === 4 && vPrefAndCount[0] < 10)) {
                                return reject('QLF Preferences must be different for tournaments the same week or consecutive (1,2,...)');
                            }
                        }
                    }

                    fetch(HOST_NAME + '/api/Edition/Entry/EnterSingleTournaments?', {
                        method: 'POST',
                        headers: new Headers({
                            'Accept': 'application/json',
                            'Content-Type': 'application/json'
                        }),
                        body: JSON.stringify(tournamentsEnteredByPlayer)
                    }).then(response => {
                        state.enterableTournaments.forEach(tournament => {
                            tournamentsEnteredByPlayer.forEach(t => {
                                if (tournament.tournamentId === t.tournamentId) {
                                    tournament.mainEnteredByPlayerBefore = tournament.mainEnteredByPlayer;
                                    tournament.qualiEnteredByPlayerBefore = tournament.qualiEnteredByPlayer;
                                }
                            });
                            tournament.mainEnteredByPlayer = false;
                            tournament.qualiEnteredByPlayer = false;
                        });
                        resolve(response);
                    }).catch(error => {
                        console.log('Error while fetching et tournaments ' + error);
                        reject(error);
                    });
                }
            });
        },
        fetchWithdrawableEntries({ commit, state }) {
            commit('updateWithdrawDataState', true);
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/Entry/GetWithdrawableTournamentEntries?' +
                    'instantAsMillis=' + state.currentDate.valueOf() + '&playerIdentifier=' + state.playerIdentifier + '&c=' + Date.now(), {
                }).then((response) => {
                    response.json().then((data) => {
                        commit('updateWithdrawableEntries', data);
                        resolve();
                    });
                }).catch((error) => {
                    reject(error);
                })
            });
        },
        withdrawEntry({ dispatch }, entry) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/Entry/WithdrawEntry', {
                    method: 'POST',
                    headers: new Headers({
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(entry.id)
                }).then(response => {
                    dispatch('fetchWithdrawableEntries').then(() => {
                        dispatch('fetchActivityEntries').then(() => {
                            resolve(response);
                        })
                    }).catch((error) => reject(error));
                }).catch(error => {
                    console.log('Error while fetching wd entries ' + error);
                    reject(error);
                });
            });
        },
        updateEntry({ dispatch }, entry) {
            return new Promise((resolve, reject) => {
                let entryIdWithPreference = entry.id;
                entryIdWithPreference.preferenceToUpdate = entry.preference;
                fetch(HOST_NAME + '/api/Edition/Entry/UpdateEntry', {
                    method: 'POST',
                    headers: new Headers({
                        'Accept': 'application/json',
                        'Content-Type': 'application/json'
                    }),
                    body: JSON.stringify(entryIdWithPreference)
                }).then(response => {
                    dispatch('fetchWithdrawableEntries').then(() => {
                        dispatch('fetchActivityEntries').then(() => {
                            resolve(response);
                        })
                    }).catch((error) => {
                        console.log('Error while fetching tournaments ' + error);
                        reject(error);
                    });
                }).catch(error => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                });
            });
        },
        fetchActivityEntries({ commit, state }) {
            return new Promise((resolve, reject) => {
                fetch(HOST_NAME + '/api/Edition/Entry/Activity?' +
                    'instantAsMillis=' + state.currentDate.valueOf() + '&playerIdentifier=' + state.playerIdentifier + '&c=' + Date.now(), {
                }).then((response) => {
                    response.json().then((data) => {
                        commit('updateActivites', data);
                        resolve();
                    });
                }).catch((error) => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                })
            });
        },
        fetchPreliminaryListDoubles({ commit, state }, tournamentIdentifier) {
            return new Promise((resolve, reject) => {
                commit('updatePreliminaryEntriesDoubles', { tournamentIdentifier: tournamentIdentifier[0], data: [{}] });
                // month() is starting at 0 for moment.js
                let currentSeasonYear = getCurrentSeason(state, tournamentIdentifier[0]);
                fetch(HOST_NAME + '/api/AcceptanceList/' + currentSeasonYear + '/' + tournamentIdentifier[0] + '/CurrentListUseCurrentRank/Doubles?c=' + Date.now()).then((response) => {
                    response.json().then((data) => {
                        commit('updatePreliminaryEntriesDoubles', { tournamentIdentifier: tournamentIdentifier[0], data: data });
                        resolve();
                    }).catch(error => {
                        console.log('Error while fetching tournaments ' + error);
                        reject(error);
                    });
                }).catch(error => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                });
            });
        },
        fetchPreliminaryList({ commit, state }, tournamentIdentifier) {
            return new Promise((resolve, reject) => {
                commit('updatePreliminaryEntries', { tournamentIdentifier: tournamentIdentifier[0], data: [{}] });
                // month() is starting at 0 for moment.js
                let currentSeasonYear = getCurrentSeason(state, tournamentIdentifier[0]);
                fetch(HOST_NAME + '/api/AcceptanceList/' + currentSeasonYear + '/' + tournamentIdentifier[0] + '/CurrentListUseCurrentRank/Singles/' + tournamentIdentifier[1] + '?c=' + Date.now()).then((response) => {
                    response.json().then((data) => {
                        commit('updatePreliminaryEntries', { tournamentIdentifier: tournamentIdentifier[0], data: data });
                        resolve();
                    }).catch(error => reject('Could not find any valid data for this list. It might be empty.'));
                }).catch(error => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                });
            });
        },
        fetchAcceptanceListDoubles({ commit, state }, tournamentIdentifier) {
            return new Promise((resolve, reject) => {
                commit('updateAcceptedEntriesDoubles', { tournamentIdentifier: tournamentIdentifier[0], data: [{}] });
                let currentSeasonYear = getCurrentSeason(state, tournamentIdentifier[0]);
                fetch(HOST_NAME + '/api/AcceptanceList/' + currentSeasonYear + '/' + tournamentIdentifier[0] + '/CurrentList/Doubles?c=' + Date.now()).then((response) => {
                    try {
                        response.json().then((data) => {
                            commit('updateAcceptedEntriesDoubles', { tournamentIdentifier: tournamentIdentifier[0], data: data });
                            resolve();
                        }).catch(error => {
                            console.log('Error while fetching tournaments ' + error);
                            reject(error);
                        });
                    } catch (e) {
                        console.log('Error while fetching tournaments ' + error);
                        reject(e);
                    }
                }).catch(error => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                });
            });
        },
        fetchAcceptanceList({ commit, state }, tournamentIdentifier) {
            return new Promise((resolve, reject) => {
                commit('updateAcceptedEntries', { tournamentIdentifier: tournamentIdentifier[0], data: [{}] });
                let currentSeasonYear = getCurrentSeason(state, tournamentIdentifier[0]);
                fetch(HOST_NAME + '/api/AcceptanceList/' + currentSeasonYear + '/' + tournamentIdentifier[0] + '/CurrentList/Singles/' + tournamentIdentifier[1] + '?c=' + Date.now()).then((response) => {
                    try {
                        response.json().then((data) => {
                            commit('updateAcceptedEntries', { tournamentIdentifier: tournamentIdentifier[0], data: data });
                            resolve();
                        }).catch(error => {
                            console.log('Error while fetching tournaments ' + error);
                            reject(error);
                        });
                    } catch (e) {
                        console.log('Error while fetching tournaments ' + error);
                        reject(e);
                    }
                }).catch(error => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                });
            });
        },
        fetchEverything({ dispatch }) {
            return new Promise((resolve, reject) => {
                dispatch('fetchDeadlines').then(() => {
                    resolve();
                }).catch((error) => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                });
            });
        },
        fetchEverythingForPrelimAndAcceptance({ dispatch }) {
            return new Promise((resolve, reject) => {
                dispatch('fetchTournaments').then(() => {
                    resolve();
                }).catch((error) => {
                    console.log('Error while fetching tournaments ' + error);
                    reject(error);
                });
            });
        }
    }

}


// WEBPACK FOOTER //
// ./src/store/singles-entry-system.js